import * as faceapi from 'face-api.js';

/**
 * The weights live in public/models, which the build copies next to index.html
 * — under PUBLIC_URL (`/hairio-stage`, `/hairio`), not at the domain root. A
 * bare '/models' 404s on stage/prod, the load fails silently and every later
 * detection throws "TinyYolov2 - load model before inference".
 */
export const FACE_API_MODELS_URL = `${process.env.PUBLIC_URL || ''}/models`;

let loadPromise: Promise<boolean> | null = null;
let isLoaded = false;

/**
 * Loads the detector once per session. Never throws — it resolves with whether
 * the net is actually usable, so a caller can fall back instead of running
 * detections that would throw "load model before inference" on every frame.
 * A failed attempt is not cached: the next call tries again.
 */
export const loadFaceApiModels = async (): Promise<boolean> => {
  // Если уже загружено - возвращаем сразу
  if (isLoaded) {
    return true;
  }

  // Если уже загружается - возвращаем существующий promise
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = (async () => {
    try {
      // Загружаем модели
      await faceapi.nets.tinyFaceDetector.loadFromUri(FACE_API_MODELS_URL);

      // Pre-warm WASM/GPU с фиктивной детекцией
      try {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = 224;
        tempCanvas.height = 224;
        await faceapi.detectSingleFace(
          tempCanvas as any,
          new faceapi.TinyFaceDetectorOptions({ inputSize: 224 })
        );
      } catch {
        // Игнорируем ошибки pre-warming
      }

      isLoaded = faceapi.nets.tinyFaceDetector.isLoaded;
      return isLoaded;
    } catch (error) {
      console.error(`Failed to load face-api models from ${FACE_API_MODELS_URL}:`, error);
      return false;
    } finally {
      loadPromise = null;
    }
  })();

  return loadPromise;
};
